// extracted by mini-css-extract-plugin
module.exports = {"Header":"header_Header__cv3kI","Mobile":"header_Mobile__rDkM1","Light":"header_Light__p1x_T","Dark":"header_Dark__ALPol","Logo":"header_Logo__yykaM"};